
import { defineComponent } from 'vue';
export default defineComponent({
  name: "vkSvg",
  props: {
    iconName: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: "",
    },
    color:{
      type:String,
      default:'#fff9'
    }
  },
  computed: {
    iconUrl(): string {
      return `#icon-${this.iconName}`;
      // return require(`@/assets/icons/${this.iconName}.svg`); 
    },
    svgClass(): string {
      if (this.className) {
        return "svg-icon " + this.className;
      } else {
        return "svg-icon";
      }
    },
    style(): { [key: string]: string } {
      return { "--color": this.color };
    }
  },
});
